<template>
  <div class="scoreboard">
    <div class="top">
      <div class="league-name" v-if="game !== null">
        <span class="white">{{game ? game.name : ''}}</span>
      </div>
      <div class="logo">
        <img src="../assets/logo.png" />
      </div>
    </div>
    <div class="bottom" v-if="game !== null">
      <transition-group name="zoom" tag="div" class="left">
        <TopThree
          v-for="(team, index) in topThree"
          :key="team.id"
          :team="team"
          :place="index"
          class="top-three"
        />
      </transition-group>
      <transition-group name="zoom" tag="div" class="right" mode="out-in">
        <ScoreHeader :key="'header'" class="score-row" />
        <ScoreRow
          v-for="(team, index) in topTen"
          :key="team.id"
          :team="team"
          :place="index"
          class="score-row"
          :startIndex="4"
        />
        <ScoreRow
          class="show-on-mobile-only"
          v-for="(team, index) in otherTeams"
          :key="team.id"
          :team="team"
          :place="index"
          :startIndex="11"
        />
      </transition-group>
    </div>
    <div v-else class="bottom empty-message">
      No games are currently running.
    </div>
  </div>
</template>

<script>
import 'vue2-animate/dist/vue2-animate.min.css';
// @ is an alias to /src
import TopThree from '@/components/TopThree.vue';
import ScoreRow from '@/components/ScoreRow.vue';
import ScoreHeader from '@/components/ScoreHeader.vue';

export default {
  name: 'home',
  components: {
    TopThree,
    ScoreRow,
    ScoreHeader,
  },
  mounted() {
    this.$store.dispatch('getGame');
  },
  computed: {
    game() {
      return this.$store.state.game;
    },
    sortedTeams() {
      const { teams } = this.$store.state;
      if (this.$store.state.game.sortLowToHigh) {
        teams.sort((a, b) => a.total - b.total);
      } else {
        teams.sort((a, b) => b.total - a.total);
      }
      return teams;
    },
    topThree() {
      return this.sortedTeams.slice(0, 3);
    },
    topTen() {
      return this.sortedTeams.slice(3, 10);
    },
    otherTeams() {
      return this.sortedTeams.slice(10);
    },
  },
};
</script>
<style lang="scss">
  .zoom-move{
    transition: transform .5s;
  }
</style>
<style lang="scss">
@mixin mobile {
    @media (max-width: 800px) { @content; }
  }

html, body, #app {
    font-size: 12px !important;
    @include mobile{
      font-size: 16px !important;
    }
  }
</style>
<style lang="scss" scoped>

  @import url('https://fonts.googleapis.com/css?family=Lato:300,400,700,900&display=swap');

  @font-face {
    font-family: 'KnockOut';
    src: url('~/font/Knockout-HTF47Bantamweight-Regular.eot');
    src: url('~/font/Knockout-HTF47Bantamweight-Regular.eot?#iefix') format('embedded-opentype'),
        url('~/font/Knockout-HTF47Bantamweight-Regular.woff') format('woff'),
        url('~/font/Knockout-HTF47Bantamweight-Regular.ttf') format('truetype'),
        url('~/font/Knockout-HTF47Bantamweight-Regular.svg#svgFontName') format('svg');
  }

  $ns-green: #12A650;

  @mixin mobile {
    @media (max-width: 800px) { @content; }
  }

  .show-on-mobile-only{
    display: none;
    @include mobile{
      display: flex;
    }
  }

  .empty-message{
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 3rem;
  }

  .scoreboard{
    font-family: 'Lato', sans-serif;
    background: black;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    @include mobile{
      height: unset;
    }
  }

  .top{
    display: flex;
    flex-direction: row;
    color: white;
    align-items: center;
    padding: 1rem 2rem;
    background: $ns-green;

    @include mobile{
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 1rem;
    }

    .logo{
      width: 12rem;
      height: auto;
      margin-right: 2rem;

      @include mobile{
        margin-right: 0;
        order: 1;
        margin-bottom: 1rem;
        width: 8rem;
      }
      img{
        width: 100%;
        height: auto;
      }
    }
    .league-name{
      flex: 1;
      font-family: 'KnockOut';
      font-size: 4.5rem;
      text-transform: uppercase;
      letter-spacing: 4px;

      color: $ns-green;
      .white{
        color: white;
      }

      @include mobile{
        font-size: 2.5rem;
        text-align: center;
        order: 2;
      }
    }
    .clock{
      font-size: 2rem;
    }
  }

  .bottom{
    flex: 1;
    display: flex;
    flex-direction: row;
    padding: 2rem;

    @include mobile{
      flex-direction: column;
      padding: 1rem;
    }

    .left{
      width: 40rem;
      display: flex;
      flex-direction: column;
      margin-right: 2rem;

      @include mobile{
        margin-right: 0;
        width: 100%;
        margin-bottom: 1rem;
      }

      .top-three{
        margin-bottom: 2rem;

        @include mobile{
          height: 9rem;
          margin-bottom: 1rem;
        }

        &:last-child{
          margin-bottom: 0;
        }
      }
    }

    .right{
      flex: 1;
      display: flex;
      flex-direction: column;

      .score-row{
        flex: 1;
        max-height: 10rem;
        &:first-child{
          flex: .5;
          max-height: 5rem;
        }
      }
    }
  }
</style>
